export interface WorkTypeConfig {
  key: string;
  label: string;
  icon: string;
  description: string;
}

export const WORK_TYPE_CONFIG: WorkTypeConfig[] = [
  {
    key: 'full_time',
    label: 'Full-time',
    icon: 'fa-solid fa-briefcase',
    description: '40+ hours per week in a professional role',
  },
  {
    key: 'part_time',
    label: 'Part-time',
    icon: 'fa-solid fa-clock',
    description: 'Balancing a professional role with school',
  },
  {
    key: 'internship',
    label: 'Internship',
    icon: 'fa-solid fa-graduation-cap',
    description: 'Gaining short-term professional experience',
  },
  {
    key: 'apprenticeship',
    label: 'Apprenticeship',
    icon: 'fa-solid fa-screwdriver-wrench',
    description: 'Gaining long-term paid training to master a trade',
  },
];

export const WORK_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  WORK_TYPE_CONFIG.map((c) => [c.key, c.label])
);

export function formatWorkType(workType: string): string {
  return WORK_TYPE_LABELS[workType] || workType;
}

export const WORK_TYPE_OPTIONS = WORK_TYPE_CONFIG.map((c) => ({
  value: c.key,
  label: c.label,
}));
